import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianStreetFieldController extends GeneralTreatingPhysicianFieldController {}
